import React from 'react';
import PropTypes from 'prop-types';

const ArrowRightIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.13903 0.833008L11.5835 5.49967M11.5835 5.49967L7.13903 10.1663M11.5835 5.49967L0.916809 5.49967"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

ArrowRightIcon.propTypes = {
  color: PropTypes.string,
};

export default ArrowRightIcon;
